import { type JSX, Show, createSignal, onMount } from "solid-js";

import { Loading } from "../Loading/Loading";

export function ClientOnly(props: {
  children: JSX.Element;
  loading?: boolean;
}) {
  const [mounted, setMounted] = createSignal(false);
  onMount(() => setMounted(true));
  return (
    <Show
      when={mounted()}
      fallback={
        <Show when={props.loading} fallback={<></>}>
          <Loading></Loading>
        </Show>
      }
    >
      {props.children}
    </Show>
  );
}
